module.exports = __webpack_public_path__ + "img/square.8df0aacc.png";